<div [style.display]="'flex'" [style.justify-content]="'center'" [style.align-items]="'center'" [style.height.px]="300"
  [id]="id">
  <h3>{{ noDataLabel }}</h3>
</div>